<template>
  <div class="remark-clr">
    <div class="remark-top">评论 {{list.length}}</div>
    <div class="main-input">
      <div class="self-r-left"></div>
      <div class="self-r-right">
        <textarea
          v-model.trim="iptVal"
          @focus="focusInput = true"
          @blur="focusInput = false"
          class="comment-textarea"
          :class="{ writing: focusInput || iptVal }"
          placeholder="说点什么吧..."
        ></textarea>
        <div class="action">
          <div @click="submit" class="submit-btn" :class="{ canSub: iptVal }">评论</div>
        </div>
      </div>
    </div>
    <div class="remark-list">
      <div class="reamrk-item" v-for="(item, index) in list" :key="index">
          <img :src="item.img" class="remark-left" alt="">
        <div class="remark-right">
          <div class="remark-name">{{ item.name }}</div>
          <div class="remark-desc">{{ item.desc }}</div>
          <div class="remark-time"><span>{{item.time}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "listLift",
  data() {
    return {
      focusInput: false,
      iptVal: "",
      list: [
        {
            name: "太空漫舞",
            desc: "真的很不错，十分的赞。以后有需求还会来这。",
            time: '2021-12-10',
            img: 'https://sf3-cdn-tos.toutiaostatic.com/img/pgc-image/80d9b352ed57449ab10ae06b3a0931f4~300x300.image'
         },
          {
          name: "聊城房客",
          desc: "服务态度还行，比较满意",
          img: 'https://sf3-cdn-tos.toutiaostatic.com/img/user-avatar/b5e78dbd0b31c3edd6144a1917386208~300x300.image',
            time: '2021-12-10',

        },
          {
          name: "白鹿",
          desc: "不太满意，不符合心中预期！",
          img: 'https://p3.toutiaoimg.com/img/mosaic-legacy/46c10002da0971bf557c~0x0.image',
            time: '2021-12-10',

        },
   
   
      ],
    };
  },
  methods: {
      submit() {
          if (!this.$isLogIn()) {
            window.sessionStorage.setItem("canReturn", window.location.href);
            this.$goLogIn()
            return
          }
          const user = this.$getUserInfo()
          if (!this.iptVal) return
          this.list.unshift({
               name: user.userName || "游客",
            desc:this.iptVal,
            time: '刚刚',
            img: 'data:image/png;base64,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'
          })
          this.iptVal = ''
          this.showToastBtm('评论成功')

      }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.remark-clr {
  width: 100%;
  .remark-top {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: #222;
  }
  .main-input {
    display: flex;
    margin-top: 24px;
    margin-bottom: 40px;
    .self-r-left {
      position: relative;
      display: inline-block;
      border: 1px solid #f2f2f2;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      background: url(data:image/png;base64,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)
        no-repeat 50%;
      background-size: contain;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .self-r-right {
      position: relative;
      overflow: hidden;
      border-radius: 8px;
      padding: 16px;
      background: #f8f8f8;
      flex: 1;
      .comment-textarea {
        display: block;
        border: 0;
        padding: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        max-height: 72px;
        width: 100%;
        height: 24px;
        font-size: 16px;
        line-height: 24px;
        color: #222;
        outline: none;
        resize: none;
        background: #f8f8f8;
        -webkit-transition: height 0.3s ease-in-out;
        -moz-transition: height 0.3s ease-in-out;
        transition: height 0.3s ease-in-out;
        &.writing {
          height: 72px;
        }
      }
      .action {
        margin-top: 12px;
        display: flex;
        justify-content: flex-end;
      }
      .submit-btn {
        border: none;
        border-radius: 4px;
        padding: 6px 18px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #fff;
        background: #b1191a;
        cursor: pointer;
        opacity: 0.3;
        &.canSub {
          opacity: 1;
        }
      }
    }
  }
  .remark-list {
    margin-top: 40px;
    .reamrk-item {
      display: flex;
      margin-bottom: 40px;
      .remark-left {
        border: 1px solid #f2f2f2;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        // background: url(data:image/png;base64,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)
        //   no-repeat 50%;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .remark-right {
        flex: 1;
        .remark-name {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: #222;
        }
        .remark-desc {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: #222;
          margin: 8px 0 12px;
        }
        .remark-time {
          font-size: 14px;
          font-weight: 500;

          color: #222;
          span {
            font-size: 14px;
            line-height: 20px;
            color: #999;
          }
        }
      }
    }
  }
}
</style>
